import { render, staticRenderFns } from "./SettlementDaysModal.vue?vue&type=template&id=584057e4&scoped=true"
import script from "./SettlementDaysModal.vue?vue&type=script&lang=js"
export * from "./SettlementDaysModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584057e4",
  null
  
)

export default component.exports